import { render } from "./Symbol.vue?vue&type=template&id=51d0882c&scoped=true&ts=true"
import script from "./Symbol.vue?vue&type=script&lang=ts"
export * from "./Symbol.vue?vue&type=script&lang=ts"

import "./Symbol.vue?vue&type=style&index=0&id=51d0882c&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d0882c"]])

export default __exports__